import { useEffect, useState } from "react";
import { postAdsGenerateSimilar } from "@/lib/adsAssistantClient";

export function AdsAssistantGenerateSimilarDialog(props: {
  open: boolean;
  templateId: string | null;
  templateName: string | null;
  socialPostId?: string | null;
  onClose: () => void;
}) {
  const { open, templateId, templateName, socialPostId, onClose } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fullPost, setFullPost] = useState("");

  useEffect(() => {
    if (!open || !templateId) return;
    setLoading(true);
    setError(null);
    setFullPost("");
    void (async () => {
      const r = await postAdsGenerateSimilar({
        template_id: templateId,
        ...(socialPostId ? { social_post_id: socialPostId } : {}),
      });
      setLoading(false);
      if (!r.ok) {
        setError(r.error);
        return;
      }
      setFullPost(r.data.full_post);
    })();
  }, [open, templateId, socialPostId]);

  if (!open || !templateId) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-4" role="dialog">
      <div className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-2xl border border-gray-200 bg-white p-4 shadow-xl dark:border-gray-700 dark:bg-zinc-900">
        <div className="flex items-start justify-between gap-2">
          <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Generate similar ad</h4>
          <button type="button" className="text-xs text-gray-500 hover:underline" onClick={onClose}>
            Close
          </button>
        </div>
        <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
          Template: <strong>{templateName ?? templateId}</strong>. Copy and paste into Meta or your platform (v1 is copy-only).
        </p>
        {loading ? <p className="mt-3 text-sm text-gray-600">Drafting…</p> : null}
        {error ? (
          <p className="mt-3 rounded-lg border border-red-200 bg-red-50 px-2 py-1.5 text-xs text-red-900">{error}</p>
        ) : null}
        {!loading && fullPost ? (
          <>
            <textarea
              className="mt-3 w-full min-h-[160px] rounded-lg border border-gray-200 px-3 py-2 text-sm dark:border-gray-600 dark:bg-zinc-950"
              value={fullPost}
              onChange={(e) => setFullPost(e.target.value)}
            />
            <button
              type="button"
              className="mt-2 rounded-lg bg-blue-600 px-3 py-2 text-xs font-semibold text-white hover:bg-blue-700"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(fullPost);
                } catch {
                  window.prompt("Copy this text:", fullPost);
                }
              }}
            >
              Copy to clipboard
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
}
